import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { styled } from '../../../styled';
import { Base } from '../controlButtons/audioIcon/slashed';
import { msgs } from '../msgs';

const RedSlashedAudioIcon = ({ className = '' }: { className?: string }): ReactElement => (
	<div className={className}>
		<Base width={12} height={14} color="#ED3945" backgroundColor="transparent" />
	</div>
);

const styles = css`
	align-items: center;
	background-color: #b2b2b2;
	border-radius: 10px;
	display: flex;
	justify-content: center;
	left: 20px;
	padding: 2px 6px;
	position: absolute;
	top: 25px;

	span {
		font-size: 11px;
		line-height: 16px;
		padding-left: 4px;
	}
`;

export const OperatorMuted = styled(({ className = '' }: { className?: string }) => {
	const { formatMessage } = useIntl();
	return (
		<div className={className}>
			<RedSlashedAudioIcon /> <span>{formatMessage(msgs.operatorMicIsMuted)}</span>
		</div>
	);
})(styles);
